import { global } from ":shared/app";

const endpoint = "mentors/";

export type GET = {
  returns: {
    id: number;
    image: string;
    name: string;
    bio: string;
    major: string;
    email: string;
    track: string;
    twitter: string;
    linkedin: string;
    calendly: string;
  }[];
};
export async function get(): Promise<GET["returns"]> {
  // return import("./mentors.mocks").then((res) => {
  //   return res.success;
  // });
  return global.api
    .getAuth(endpoint)
    .then((res) => {
      let res_list = res.data as any[];
      res_list = res_list.sort((a, b) => b.id - a.id);
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      // message: service.api.decode_error(err, "couldn't update password"),
      return Promise.reject(err.message);
    });
}
